import React, { PureComponent } from "react";
import SvgIcon from "material-ui/SvgIcon";

class Sort extends PureComponent {
    render() {
        return (
            <SvgIcon {...this.props}>
                <path d="M22.5,2h-21C0.7,2,0,2.7,0,3.5v0C0,4.3,0.7,5,1.5,5h21C23.3,5,24,4.3,24,3.5v0C24,2.7,23.3,2,22.5,2z" />
                <path d="M22.5,10h-15C6.7,10,6,10.7,6,11.5v0C6,12.3,6.7,13,7.5,13h15c0.8,0,1.5-0.7,1.5-1.5v0C24,10.7,23.3,10,22.5,10z" />
                <path d="M22.5,18h-9c-0.8,0-1.5,0.7-1.5,1.5v0c0,0.8,0.7,1.5,1.5,1.5h9c0.8,0,1.5-0.7,1.5-1.5v0C24,18.7,23.3,18,22.5,18z" />
            </SvgIcon>
        );
    }
}

export default Sort;
